module.exports = {
      id: "download-usage",
      viewBox: "0 0 24 24",
      url: "/" + "sprite-ab56b996b385d9abaaf31e01c38c81cd.svg#download",
      toString: function () {
        return this.url;
      }
    }